// File for logic corresponding to info component
import { Component } from 'js-component-framework';
import checkBreakpoint from '@/client/src/js/utils/checkBreakpoint';
import insertAfter from '@/client/src/js/utils/insertAfter';
import debounce from 'lodash.debounce';

// Styles
import './info.scss';

/**
 * Component for info
 */
export default class Info extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Methods
    this.setEnrollBtnPos();
    this.manageEnrollResponsive();
  }

  setEnrollBtnPos() {
    // Check button is present.
    if (!this.children.enrollBtn) {
      return;
    }

    const breakpointCheck = checkBreakpoint();

    // If opened on desktop move to reference el.
    if (breakpointCheck === 'desktop') {
      insertAfter(this.children.enrollBtn, this.children.enrollDesktopEl);
    }
  }

  manageEnrollResponsive() {
    // Debounce for responsive behavior
    window.addEventListener('resize', debounce(() => {
      const breakpointCheck = checkBreakpoint();

      if (breakpointCheck === 'desktop') {
        insertAfter(this.children.enrollBtn, this.children.enrollDesktopEl);
      } else {
        insertAfter(this.children.enrollBtn, this.children.enrollMobileEl);
      }
    }, 300));
  }
}
